exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-dialog[data-v-fa336230] {\n    min-width: 700px;\n}\n", ""]);

// exports
